module.exports = __webpack_public_path__ + "img/intelligence.230af8a4.svg";